/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const TableBody = styled.div`
  width: 100%;
  display: flex;
  border-top: 1px solid ${Palette.PrimaryGray._200};
`;

export const ScrollWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const RowsWrap = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
`;

export const Header = styled.div`
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${({ isNoData }) => (isNoData ? '64px' : '64px 48px')};
  z-index: 400;
`;

export const Row = styled.div`
  height: 72px;
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
  background-color: ${({ isChecked }) =>
    isChecked ? `${Palette.Primary._100} !important` : 'unset'};

  &:nth-child(even) {
    background-color: #e9eff6;
  }

  &:last-child {
    border-bottom: unset;
    height: ${({ isScroll }) => (isScroll ? '84px' : '72px')};

    & > * {
      padding-bottom: ${({ isScroll }) => (isScroll ? '12px' : 'unset')};
    }
  }
`;

export const RightSide = styled.div`
  width: calc(100% - 400px);
`;

export const LeftSide = styled.div`
  position: relative;
  width: 400px;
  flex-shrink: 0;
  z-index: 1;

  &::after {
    content: ' ';
    display: block;
    position: absolute;
    top: 0;
    right: -20px;
    width: 20px;
    height: 100%;
    box-shadow: rgba(100, 116, 139, 0.42) 8px 0px 16px -12px inset;
    pointer-events: none;
    transition: opacity 0.2s;
    opacity: 0;
  }

  &.shadow::after {
    opacity: 1;
  }
`;

export const ScrollBar = styled.div`
  position: sticky;
  bottom: 0;
  height: 0px;
  width: 100%;
  display: flex;
  cursor: grab;
`;

export const ScrollBarSpace = styled.div`
  width: 100%;
  background-color: white;
  border-top: 1px solid ${Palette.PrimaryGray._200};
  height: 16px;
`;

export const RightScrollBlock = styled.div`
  height: 10px;
  width: 100%;
  margin-left: 400px;
  overflow-y: hidden;
  overflow-x: auto;
  transform: translateY(-14px);
  cursor: grab;

  ::-webkit-scrollbar {
    background-color: transparent;
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;

export const ScrollInner = styled.div`
  width: 100%;
`;
